"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    FAVICON_ENV: 'staging',
    KEYCLOAK: {
        CLIENT_ID: 'newfront-web',
        REALM: {
            CLIENTS: 'newfront-clients',
            EMPLOYEES: 'newfront',
        },
    },
    API: {
        ACCOUNTS: 'https://stage-api-account.newfront-development.com',
        ADDRESS: 'https://stage-api-address.newfront-development.com',
        AUTH: 'https://stage-api-auth.newfront-development.com/auth',
        BULK_IMPORT: 'https://stage-api-bulk-import.newfront-development.com',
        CASE_MANAGEMENT: 'https://stage-api-case-mgmt.newfront-development.com',
        CLAIMS: 'https://stage-api-claims.newfront-development.com',
        CONVERSION: 'https://stage-api-conversion.newfront-development.com',
        COVERAGE: 'https://stage-api-coverage.newfront-development.com',
        DOCUMENT_RENDERING: 'https://stage-api-doc-rendering.newfront-development.com',
        DOD: 'https://stage-api-dod.newfront-development.com',
        EMAIL_LOGGER: 'https://stage-api-email-logger.newfront-development.com',
        EXPOSURES: 'https://stage-api-exposures.newfront-development.com',
        FILES: 'https://stage-api-files.newfront-development.com',
        LEAD: 'https://stage-api-lead.newfront-development.com',
        NEWFRONTAPP: 'https://stage-api-newfrontapp.newfront-development.com',
        NOTIFICATIONS: 'https://stage-api-ntfns.newfront-development.com',
        PAYMENTS: 'https://stage-api-payments.newfront-development.com',
        PROOF_OF_INSURANCE: 'https://stage-api-poi.newfront-development.com',
        PROPOSAL: 'https://stage-api-proposal.newfront-development.com',
        QUOTING: 'https://stage-api-quoting.newfront-development.com',
        TASK: 'https://stage-api-task.newfront-development.com',
        TRADING_PARTNERS: 'https://stage-api-tp.newfront-development.com',
        USERS: 'https://stage-api-users.newfront-development.com',
    },
    SUB_APPS: {
        BULK_IMPORT: 'https://bulk-import-staging.newfront-preview.com/import',
        CERTIFICATES: 'https://proof-of-insurance-staging.newfront-preview.com/certificates',
        CLAIMS: 'https://claims-staging.newfront-preview.com/claims-app',
        CONVERSION: 'https://conversion-staging.newfront-preview.com/conversion',
        COVERAGE: 'https://coverage-staging.newfront-preview.com/admin/coverage',
        EXPOSURES: 'https://exposures-staging.newfront-preview.com/exposures',
        FILES: 'https://files-app-v2-staging.newfront-preview.com/files',
        PAYMENTS: 'https://payments-staging.newfront-preview.com/payments',
        QUOTING: 'https://quoting-staging.newfront-preview.com/quoting',
        TRADING_PARTNERS: 'https://trading-partners-git-staging.newfront-preview.com/trading-partners',
    },
    SENTRY: {
        ENABLED: false,
        ENVIRONMENT: 'staging',
        DSN: {
            ACCOUNTS: 'https://a4b95d3e05a54e7e92912e67fad5cb16@o570074.ingest.sentry.io/6180684',
            CERTIFICATES: 'https://cad5ce96ab82430e8c59d739407012d9@o570074.ingest.sentry.io/6591477',
            CLIENT_DASH: 'https://1ce8be9f2df340cfbcb3639c27655f04@o570074.ingest.sentry.io/6228996',
            CONVERSION: 'https://a590b4991e17407e8f03fd24bf5faab5@o570074.ingest.sentry.io/6242079',
            FILES: 'https://46938d1238fb427d971cce80f46e77f4@o570074.ingest.sentry.io/5718276',
            PAYMENTS: 'https://619f96f5916f4af5b88cdefb4b820076@o570074.ingest.sentry.io/6326832',
            QUOTING: 'https://084b05dd86324446b04fd5ef2b1b00dc@o570074.ingest.sentry.io/6271695',
        },
    },
    LINKS: {
        BULK_IMPORT_APP: 'https://dash.newfront-staging.com/import',
        CERTIFICATES_APP: 'https://dash.newfront-staging.com/certificates',
        CLAIMS_APP: 'https://dash.newfront-staging.com/claims-app',
        CLIENT_DASH_APP: 'https://app.newfront-staging.com',
        CONVERSION_APP: 'https://dash.newfront-staging.com/conversion',
        COVERAGE_APP: 'https://dash.newfront-staging.com/admin/coverage',
        DASH_APP: 'https://dash.newfront-staging.com',
        EXPOSURES_APP: 'https://dash.newfront-staging.com/exposures',
        FILES_APP: 'https://dash.newfront-staging.com/files',
        INDIO: 'https://newfront-staging.useindio.com',
        LEGACY_DASH_APP: 'https://stage-legacy.newfront-development.com',
        LEGACY_FILES_APP: 'https://dash.newfront-staging.com/files-app',
        MARKETING_SITE: 'https://www.newfront-staging.com',
        PAYMENTS_APP: 'https://dash.newfront-staging.com/payments',
        PROPOSAL_APP: 'https://legacy.newfront-staging.com/proposal',
        QUOTING_APP: 'https://dash.newfront-staging.com/quoting',
        SERVICECLOUD_URL: 'https://newfront--stage1.lightning.force.com',
        TECHCANARY_URL: 'https://newfronttc--staging.my.salesforce.com',
        TRADING_PARTNERS_APP: 'https://dash.newfront-staging.com/trading-partners',
    },
    GOOGLE_AUTH: {
        GAPI_CLIENT_ID: '179409723826-psv82suai0jo0l6cdgl4oosdgb6fcerj.apps.googleusercontent.com',
    },
    GOOGLE_SEARCH: {
        ENVIRONMENT: 'staging',
        APPLICATIONS: {
            FILES: 'a03b03b551d9f9c2d6eae7c5a71fe6b4',
            GLOBAL_SEARCH: 'a03b03b551d9f9c20ce5230cb589e32e',
            LEGACY_FILES: 'a03b03b551d9f9c2ad42437e633fabe1',
        },
        DATA_SOURCES: {
            ACCOUNTS: 'a03b03b551d9f9c2f336dde4913b0c02',
            FILES: 'a03b03b551d9f9c2a07d99964adef7b4',
            LEGACY_FILES: 'a03b03b551d9f9c2f06b8e29a04c4d44',
            POLICIES: 'a03b03b551d9f9c29081e2315b338563',
        },
    },
    LAUNCH_DARKLY: {
        PROJECTS: {
            CLIENT_DASH: '62472238978a2f1519421057',
            ADMIN_DASH: '5e5fef5aa7ff490a8b054bf8',
        },
    },
    PLAID: {
        ENVIRONMENT: 'https://development.plaid.com',
    },
    SEGMENT: {
        SOURCES: {
            CLIENT_DASH: '1oCyaafUaekERJgYCd3J2uJjhBDLHWNj',
            ADMIN_DASH: '1oCyaafUaekERJgYCd3J2uJjhBDLHWNj',
        },
    },
    DATADOG: {
        ENABLE_CONSOLE_LOGGING: true,
        ENABLE_DATADOG_LOGGING: false,
    },
    DEFAULT_USERS: {
        ACCOUNT_MANAGER: 'b9485294-6014-4395-9b76-f919e5cd54fe',
        PRODUCER: '161c83a6-b941-4064-908a-8df6aecabcda',
        BOR_ACCOUNT_MANAGER: '004b1cb1-3f7b-4832-9b8d-abe5438510f1',
    },
};
exports.default = config;
//# sourceMappingURL=staging.js.map